<template lang="pug">

    div

        .field
            .ui.toggle.checkbox
                input(type='checkbox' v-model="isPriceRequest")
                label Nur Preisanfrage

        .field(v-show='!isPriceRequest')
            label Liefertermin

            .grouped.fields
                .field
                    .ui.radio.checkbox
                        input#tdate(type='radio' name="type" value="date" v-model="type")
                        label(for='tdate') Bestimmtes Wunschdatum

                .field
                    .ui.radio.checkbox
                        input#tasap(type='radio' name="type" value="ASAP" v-model="type")
                        label(for='tasap') So schnell wie möglich

                .field
                    .ui.radio.checkbox
                        input#ttba(type='radio' name="type" value="TBA" v-model="type")
                        label(for='ttba') Wird nachgereicht

        //- Wunschdatum
        date-field(
            label='Wunschdatum'
            v-bind:isRequired='type === "date"'
            v-model='deliveryDate'
            v-show="type === 'date'"
        )
            error(:$v='$v.deliveryDate' validator='required')
                | Darf nicht leer sein. Bitte ein Wunschdatum auswählen

        //- Druckunterlagen an ZMÜK
        date-field(
            label='Druckunterlagen an ZMÜK'
            v-model='printingMaterialToZmuek'
            v-show='!isPriceRequest'
        )


</template>

<script>
    import * as R from 'ramda'
    import { requiredIf } from 'vuelidate/lib/validators'
    import DateField from '@/components/form/DateField'
    import Error from '@/components/form/FieldError'

    export default {

        components: { DateField, Error },

        computed: {
            deliveryDate: {
                get() { return this.value.deliveryDate },
                set(value) { this.updateValue('deliveryDate', value) }
            },
            printingMaterialToZmuek: {
                get() { return this.value.printingMaterialToZmuek },
                set(value) { this.updateValue('printingMaterialToZmuek', value) }
            }
        },

        created() {
            // ggf. Standardwert fuer Lieferdatum setzen
            if (R.isNil(this.deliveryDate)) {
                this.deliveryDate = 'ASAP'
            }
        },

        data() {
            return {
                isPriceRequest: false,
                type: 'ASAP'
            }
        },

        methods: {
            updateValue(target, value) {
                this.$emit('input', { ...this.value, [target]: value })
            }
        },

        props: {
            value: {
                type: Object,
                required: true
            }
        },

        validations: {
            deliveryDate: {
                required: requiredIf(vm => vm.type === 'date')
            },
        },

        watch: {
            isPriceRequest(value) {
                if (value === true) {
                    this.type = 'asap'
                    this.$emit('input', {
                        ...this.value,
                        deliveryDate: undefined,
                        printingMaterialToZmuek: undefined
                    })
                }
            },
            type(value) {
                if (value === 'TBA' || value === 'ASAP') {
                    this.deliveryDate = value
                }
            }
        }

    }

</script>
